import { Box, Stack } from '@mui/material'
import React from 'react'
import { css, keyframes } from "@emotion/react";

import { Color, FontStyle } from '../constants'

const tease = () => keyframes`
    0% {
        transform: scale(1);
    }
    10% {
        transform: scale(1.025);
    }
    100% {
        transform: scale(1);
    }
`;
const styles = {
    container: {
        border: `1px solid ${Color.borderGray}`,
        // backgroundColor: Color.primary,
        position: 'relative',
        backgroundColor: 'white',
        color: 'black',
        borderRadius: '0.75rem',
        padding: '0.69rem 1.5rem',
        // margin: '0.48rem 0.48rem 0px 0px',
        cursor: 'pointer',
        userSelect: 'none',
        textAlign: 'center',
        width: 'fit-content',
        backgroundColor: 'white',
        '&:hover': {
            animation: `${tease()} 0.3s ease-in-out 0s`,
        },
    },
    containerDisabled: {
        color: 'rgb(122, 122, 104)',
        cursor: '',
        '&:hover': {
        },
    },
    selected: {
        backgroundColor: Color.primary,
    },
    text: {
        ...FontStyle.body,
        fontSize: '16px',
        transition: 'all 0.3s ease-in-out 0s',
        // transform: 'translateX(-0.7rem)',
    },
    textSelected: {
        transform: 'translateX(0.75rem)',
    },
    icon: {
        position: 'absolute',
        left: '0.75rem',
        transition: 'all 0.3s cubic-bezier(0.8, 1.64, 0.6, 1) 0s',
        opacity: 0,
        transform: 'translateY(-50%)'
    },
    iconSelected: {
        opacity: 1,
        transform: 'scale(1)',
    },
    iconHideBelow: {
        opacity: 0,
        transform: 'translateY(50%)',
    },
}

const HeartButtonTwoStep = ({ text, selected, selectedTwice, setSelected, disabled }) => {
    return (
        <Stack direction='row' sx={{ ...styles.container, ...(selected && styles.selected), ...(disabled && styles.containerDisabled) }} onClick={() => setSelected(!selected)}>
            <Box sx={{ ...styles.icon, ...(selected && (selectedTwice ? styles.iconHideBelow : styles.iconSelected)) }}>
                ✓
            </Box>
            <Box sx={{
                ...styles.icon,
                ...(selectedTwice && styles.iconSelected),
                // effect below will make peach go downwards. right now I think going upwards looks better
                // ...(!selected && !selectedTwice && styles.iconHideBelow)
            }}>❤️</Box>
            <Box sx={{ ...styles.text, ...(selected && styles.textSelected) }}>
                {text}</Box>
        </Stack>
    )
}

export default HeartButtonTwoStep